module.exports = __webpack_public_path__ + "static/images/design-img.d9a4f04.png";